var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "selector-container" },
    [
      _c("div", { staticClass: "text-xl font-bold text-primary mb-6" }, [
        _vm._v("\n        " + _vm._s(_vm.label) + "\n    "),
      ]),
      _vm._v(" "),
      _vm.hasItems
        ? _c(
            "vs-row",
            { staticClass: "mb-6" },
            [
              _c(
                "vs-col",
                { attrs: { "vs-w": "6" } },
                [
                  _c("vs-input", {
                    staticClass: "w-full",
                    attrs: { label: _vm.searchText, name: "filter" },
                    model: {
                      value: _vm.search,
                      callback: function ($$v) {
                        _vm.search = $$v
                      },
                      expression: "search",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "text-center" }, [
        _vm._v("\n        " + _vm._s(_vm.dragText) + "\n    "),
      ]),
      _vm._v(" "),
      _vm.hasItems
        ? _c(
            "vs-row",
            { staticClass: "mt-2" },
            [
              _c(
                "vs-col",
                { attrs: { "vs-w": "5.5" } },
                [
                  _c(
                    "vs-list",
                    [
                      _c("vs-list-header", {
                        staticClass: "text-lg",
                        attrs: { title: _vm.availableText, color: "primary" },
                      }),
                      _vm._v(" "),
                      _c(
                        "vs-list",
                        { staticClass: "scrollable_list" },
                        [
                          _vm.groupBy
                            ? [
                                _vm._l(
                                  _vm.availableList,
                                  function (value, groupName) {
                                    return [
                                      _c("vs-list-header", {
                                        attrs: {
                                          color: "primary",
                                          title: groupName,
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "draggable",
                                        {
                                          staticClass: "p-2 cursor-move",
                                          attrs: {
                                            value: _vm.availableList[groupName],
                                            group: "draggable",
                                          },
                                        },
                                        _vm._l(
                                          value,
                                          function (availableItem, i) {
                                            return _c("vs-list-item", {
                                              key: `available-item-${groupName}-${i}`,
                                              attrs: {
                                                title:
                                                  _vm.template(availableItem),
                                              },
                                            })
                                          }
                                        ),
                                        1
                                      ),
                                    ]
                                  }
                                ),
                              ]
                            : [
                                _c(
                                  "draggable",
                                  {
                                    staticClass: "p-2 cursor-move",
                                    attrs: { group: "draggable" },
                                  },
                                  _vm._l(
                                    _vm.availableList,
                                    function (availableItem, i) {
                                      return _c("vs-list-item", {
                                        key: `available-item-${i}`,
                                        attrs: {
                                          title: _vm.template(availableItem),
                                        },
                                      })
                                    }
                                  ),
                                  1
                                ),
                              ],
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              [
                _c(
                  "vs-col",
                  {
                    attrs: {
                      "vs-type": "flex",
                      "vs-justify": "center",
                      "vs-align": "center",
                      "vs-w": "1",
                    },
                  },
                  [
                    _c("chevrons-right-icon", {
                      staticClass: "custom-class",
                      attrs: { size: "3x", stroke: "rgb(var(--vs-primary))" },
                    }),
                  ],
                  1
                ),
              ],
              _vm._v(" "),
              _c(
                "vs-col",
                { attrs: { "vs-w": "5.5" } },
                [
                  _c(
                    "vs-list",
                    [
                      _c("vs-list-header", {
                        staticClass: "text-lg",
                        attrs: { title: _vm.selectedText, color: "primary" },
                      }),
                      _vm._v(" "),
                      _c(
                        "draggable",
                        {
                          staticClass: "p-2 cursor-move scrollable_list",
                          attrs: {
                            group: "draggable",
                            emptyInsertThreshold: 250,
                            direction: "horizontal",
                          },
                          on: { input: _vm.onSelectedChange },
                          model: {
                            value: _vm.selected,
                            callback: function ($$v) {
                              _vm.selected = $$v
                            },
                            expression: "selected",
                          },
                        },
                        _vm._l(_vm.selected, function (selectedItem, i) {
                          return _c("vs-list-item", {
                            key: `selected-item-${i}`,
                            attrs: { title: _vm.template(selectedItem) },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            2
          )
        : _vm.loading
        ? _c("vs-row", { staticClass: "selector-container empty" }, [
            _c("p", [_vm._v("Chargement en cours...")]),
          ])
        : _c("vs-row", { staticClass: "selector-container empty" }, [
            _c("p", [_vm._v(_vm._s(_vm.emptyText))]),
            _vm._v(" "),
            _vm.addUrl
              ? _c("a", { on: { click: _vm.redirect } }, [
                  _vm._v(_vm._s(_vm.addText)),
                ])
              : _vm._e(),
          ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }